export const industryOptions = [
  { value: "real_estate", label: "Real Estate" },
  { value: "investment", label: "Investment" },
  { value: "aif", label: "AIF" },
  { value: "aifm", label: "AIFM" },
  { value: "construction", label: "Construction" },
  { value: "pharma_life_sc", label: "Pharmaceutical & Life Sciences" },
  { value: "industrial", label: "Industrial" },
  { value: "retail", label: "Retail" },
  { value: "fmcg", label: "FMCG" },
  { value: "automotive", label: "Automotive" },
  { value: "telecom", label: "Telecom" },
  { value: "hospitality", label: "Hospitality" },
  { value: "info_tech", label: "Information & Technology" },
  { value: "media", label: "Media" },
  { value: "transport", label: "Transportation" },
  { value: "shipping", label: "Shipping" },
  { value: "aviation", label: "Aviation" },
  { value: "fintech", label: "Fintech" },
  { value: "gaming", label: "Gaming" },
  { value: "energy", label: "Energy" },
  { value: "consulting", label: "Consulting" },
  { value: "oil_gas", label: "Oil & Gas" },
  { value: "assurance", label: "Assurance" },
  { value: "banking_finance", label: "Banking & Finance" }
];

export const sizeOptions = [
  { value: "Very Small", label: "Very Small" },
  { value: "Small", label: "Small" },
  { value: "Medium", label: "Medium" },
  { value: "Large", label: "Large" }
];

export const capitalizationOptions = [
  { value: "Small", label: "Small" },
  { value: "Medium", label: "Medium" },
  { value: "Large", label: "Large" },
  { value: "Very Large", label: "Very Large" }
];

export const mainCategoryOptions = [
  { value: "AML_CFT", label: "AML/CFT", sublabel: "See how you can prevent illicit finance." }, //previously AML
  { value: "Asset_Management", label: "Asset Management" }, //previously AEAPP
  { value: "Assurance_Audit", label: "Assurance/External Audit" }, //new framework
  { value: "Commercial_Law", label: "Commercial Law" }, //new framework
  { value: "Corporate_Governance", label: "Corporate Governance", sublabel: "Determine how you can have effective oversight." }, //previously Corporate Governance
  { value: "Corporate_Law", label: "Corporate Law" }, //new framework
  { value: "Data_Privacy", label: "Data Privacy", sublabel: "Explore ways to protect data from misuse." }, //previously GDPR
  { value: "Energy", label: "Energy" }, //new framework
  { value: "ESG_And_Sustainability", label: "ESG & Sustainability" }, //new
  {
    value: "Global_Internal_Audit_Standards",
    label: "Global Internal Audit Standards"
  }, //previously ICS
  { value: "Health_Safety", label: "Health & Safety" }, //new framework
  { value: "Integrity", label: "Integrity" }, //new framework
  { value: "IT_Law", label: "IT Law" }, //new framework
  { value: "Labour", label: "Labour" }, //new framework
  { value: "Other", label: "Other" }, //same //only for corpo
  { value: "Other_Misc", label: "Other/Miscellaneous" }, //new framework
  { value: "Public_Procurement", label: "Public Procurement Law" }, //new framework
  { value: "WB", label: "Whistleblowing", sublabel: "Uncover how to reveal company wrongdoing." }, //same
];
//old frameworks v2
//[
//   { value: "AML", label: "AML" },
//   { value: "WB", label: "WhistleBlowing" },
//   { value: "GDPR", label: "GDPR" },
//   { value: "Corporate Governance", label: "Corporate Governance" },
//   { value: "ICS", label: "Πρότυπα Εσωτερικού Ελέγχου" },
//   { value: "STOCKEXLEG", label: "Χρηματιστηριακή Νομοθεσία" },
//   { value: "AEAPP", label: "ΑΕΑΠΠ-ΑΕΔΟΕΕ" },
//   { value: "Other", label: "Other" }
// ];
// old frameworks v1
// [
//   { value: "AML", label: "AML" },
//   { value: "Corporate Governance", label: "Corporate Governance" },
//   { value: "GDPR", label: "GDPR" },
//   { value: "Real Estate", label: "Real Estate" },
//   { value: "SOX", label: "SOX" },
//   { value: "COVID-19", label: "COVID-19" },
//   { value: "HIPAA", label: "HIPAA" },
//   { value: "NIST", label: "NIST" }
// ];

//organizations page
export const companyTypeOptions = [
  { value: "avete", label: "ICTSA" },
  { value: "ae", label: "SA" },
  { value: "aedoee", label: "AIFM" },
  { value: "aeeap", label: "REIC" },
  // { value: "aeoel", label: "ΑΕΟΕΛ" },
  { value: "akes", label: "CMF" },
  { value: "amke", label: "CNPC" },
  { value: "ane", label: "SC" },
  { value: "public_sector", label: "PSE" },
  { value: "ee", label: "LP" },
  { value: "epe", label: "LLC" },
  { value: "institute", label: "FOUNDATION" },
  { value: "ike", label: "PC" },
  { value: "mko", label: "NGO" },
  { value: "oe", label: "GP" },
  { value: "financial", label: "FI" },
  { value: "brs", label: "BRS" },
  { value: "grc", label: "GRC" },
  { value: "hr", label: "HR" },
  { value: "it", label: "IT" },
  { value: "legal", label: "LEGAL" },
  { value: "qrm", label: "QUALITY & RISK MANAGEMENT"},
];

//stocks exchange options
export const stocksExchangeOptions = [
  { value: "ATHEX", label: "ATHEX" },
  { value: "CY", label: "CY" },
  { value: "UK", label: "UK" },
  { value: "US", label: "US" }
];

//currency options
export const currencyOptions = [
  {
    locale: "de-DE",
    currency: "EUR"
  },
  {
    locale: "en-US",
    currency: "USD"
  },
  {
    locale: "en-GB",
    currency: "GBP"
  },
  {
    locale: "ja-JP",
    currency: "JPY"
  },
  {
    locale: "en-IN",
    currency: "INR"
  }
];

//law type options
export const lawTypeOptions = [
  { value: "LAW", label: "Act / Law" },
  { value: "MINISTRY_DECISION", label: "Ministerial Decision" },
  { value: "DECREE", label: "Presidential Decree" },
  { value: "REGULATION", label: "European Regulation" },
  { value: "DIRECTIVE", label: "European Directive" },
  {
    value: "GUIDELINE",
    label: "Guideline of Supervisory / Regulatory Authority"
  },
  { value: "AUTH_DECISION", label: "Decision of Supervisory / Regulatory Authority" },
  { value: "AUTH_CIRCULAR", label: "Circular of Supervisory / Regulatory Authority" }
];

export const turnoverRangeOptions = [
  { value: "_10", label: "Less than 10mill €" },
  { value: "10_40", label: "10-40mill €" },
  { value: "40_", label: "40mill € and above" }
];

export const totalAssetsRangeOptions = [
  { value: "_50", label: "Less than 50mill €" },
  { value: "50_200", label: "50-200mill €" },
  { value: "200_500", label: "200-500mill €" },
  { value: "500_", label: "500mill € and above" }
];

export const numberOfEmployeesRangeOptions = [
  { value: "1_20", label: "1-20" },
  { value: "21_50", label: "21-50" },
  { value: "50_", label: "50 and above" }
];

export const balanceSheetRangeOptions = [
  { value: "_10", label: "Less than 10mill €" },
  { value: "10_40", label: "10-40mill €" },
  { value: "40_", label: "40mill € and above" }
];

export const userRoles = [
  { value: "masterEditor", label: "Master Editor" },
  { value: "corporateEditor", label: "Corporate Editor" },
  { value: "groupComplianceAssessor", label: "Group Compliance Assessor" },
  {
    value: "corporateComplianceAssessor",
    label: "Corporate Compliance Assessor"
  },
  { value: "assignedUser", label: "Assigned User" },
  {
    value: "groupComplianceObserver",
    label: "Group Compliance Observer"
  },
  {
    value: "corporateComplianceObserver",
    label: "Corporate Compliance Observer"
  }
];

export const roleAuditOptions = [
  { value: "AUDIT_MANAGER", label: "Audit Manager" },
  { value: "AUDITEE", label: "Auditee" },
  { value: "AUDITOR", label: "Auditor" }
];

export const departmentOptions = [
  { value: "BusinessUnit", label: "Business Unit" },
  {
    value: "LegalAndRegulatoryAffairs",
    label: "Legal and Regulatory Affairs"
  },
  { value: "RiskManagement", label: "Risk Management" },
  {
    value: "AdministrativeAndSupportUnit",
    label: "Administrative and Support Unit"
  },
  { value: "OperationsUnit", label: "Operations Unit" },
  { value: "FinanceAndAccounting", label: "Finance and Accounting" },
  { value: "SalesAndMarketing", label: "Sales and Marketing" },
  {
    value: "TechnologyAndInformationSystems",
    label: "Technology and Information Systems"
  },
  { value: "ProductServiceUnit", label: "Product/Service Unit" },
  {
    value: "ComplianceRiskAndSecurity",
    label: "Compliance, Risk, and Security"
  },
  { value: "CustomerRelations", label: "Customer Relations" },
  {
    value: "EnvironmentalSocialAndGovernanceESG",
    label: "Environmental, Social, and Governance (ESG)"
  },
  {
    value: "CorporateDevelopmentAndStrategy",
    label: "Corporate Development and Strategy"
  },
  { value: "ProjectManagement", label: "Project Management" }
];

export const countryOptions = [
  { value: "Afghanistan", label: "Afghanistan" },
  { value: "Albania", label: "Albania" },
  { value: "Algeria", label: "Algeria" },
  { value: "Andorra", label: "Andorra" },
  { value: "Angola", label: "Angola" },
  { value: "AntiguaAndBarbuda", label: "Antigua and Barbuda" },
  { value: "Argentina", label: "Argentina" },
  { value: "Armenia", label: "Armenia" },
  { value: "Australia", label: "Australia" },
  { value: "Austria", label: "Austria" },
  { value: "Azerbaijan", label: "Azerbaijan" },
  { value: "Bahamas", label: "Bahamas" },
  { value: "Bahrain", label: "Bahrain" },
  { value: "Bangladesh", label: "Bangladesh" },
  { value: "Barbados", label: "Barbados" },
  { value: "Belarus", label: "Belarus" },
  { value: "Belgium", label: "Belgium" },
  { value: "Belize", label: "Belize" },
  { value: "Benin", label: "Benin" },
  { value: "Bhutan", label: "Bhutan" },
  { value: "Bolivia", label: "Bolivia" },
  { value: "BosniaAndHerzegovina", label: "Bosnia and Herzegovina" },
  { value: "Botswana", label: "Botswana" },
  { value: "Brazil", label: "Brazil" },
  { value: "Brunei", label: "Brunei" },
  { value: "Bulgaria", label: "Bulgaria" },
  { value: "BurkinaFaso", label: "Burkina Faso" },
  { value: "Burundi", label: "Burundi" },
  { value: "CaboVerde", label: "Cabo Verde" },
  { value: "Cambodia", label: "Cambodia" },
  { value: "Cameroon", label: "Cameroon" },
  { value: "Canada", label: "Canada" },
  { value: "CentralAfricanRepublic", label: "Central African Republic" },
  { value: "Chad", label: "Chad" },
  { value: "Chile", label: "Chile" },
  { value: "China", label: "China" },
  { value: "Colombia", label: "Colombia" },
  { value: "Comoros", label: "Comoros" },
  {
    value: "CongoDemocraticRepublic",
    label: "Congo, Democratic Republic of the"
  },
  { value: "CongoRepublic", label: "Congo, Republic of the" },
  { value: "CostaRica", label: "Costa Rica" },
  { value: "CoteDIvoire", label: "Cote d'Ivoire" },
  { value: "Croatia", label: "Croatia" },
  { value: "Cuba", label: "Cuba" },
  { value: "Cyprus", label: "Cyprus" },
  { value: "CzechRepublic", label: "Czech Republic" },
  { value: "Denmark", label: "Denmark" },
  { value: "Djibouti", label: "Djibouti" },
  { value: "Dominica", label: "Dominica" },
  { value: "Dominican Republic", label: "Dominican Republic" },
  { value: "EastTimorTimorLeste", label: "East Timor (Timor-Leste)" },
  { value: "Ecuador", label: "Ecuador" },
  { value: "Egypt", label: "Egypt" },
  { value: "ElSalvador", label: "El Salvador" },
  { value: "EquatorialGuinea", label: "Equatorial Guinea" },
  { value: "Eritrea", label: "Eritrea" },
  { value: "Estonia", label: "Estonia" },
  { value: "Eswatini", label: "Eswatini" },
  { value: "Ethiopia", label: "Ethiopia" },
  { value: "Fiji", label: "Fiji" },
  { value: "Finland", label: "Finland" },
  { value: "France", label: "France" },
  { value: "Gabon", label: "Gabon" },
  { value: "Gambia", label: "Gambia" },
  { value: "Georgia", label: "Georgia" },
  { value: "Germany", label: "Germany" },
  { value: "Ghana", label: "Ghana" },
  { value: "Greece", label: "Greece" },
  { value: "Grenada", label: "Grenada" },
  { value: "Guatemala", label: "Guatemala" },
  { value: "Guinea", label: "Guinea" },
  { value: "GuineaBissau", label: "Guinea-Bissau" },
  { value: "Guyana", label: "Guyana" },
  { value: "Haiti", label: "Haiti" },
  { value: "Honduras", label: "Honduras" },
  { value: "Hungary", label: "Hungary" },
  { value: "Iceland", label: "Iceland" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Iran", label: "Iran" },
  { value: "Iraq", label: "Iraq" },
  { value: "Ireland", label: "Ireland" },
  { value: "Israel", label: "Israel" },
  { value: "Italy", label: "Italy" },
  { value: "Jamaica", label: "Jamaica" },
  { value: "Japan", label: "Japan" },
  { value: "Jordan", label: "Jordan" },
  { value: "Kazakhstan", label: "Kazakhstan" },
  { value: "Kenya", label: "Kenya" },
  { value: "Kiribati", label: "Kiribati" },
  { value: "KoreaNorth", label: "Korea, North" },
  { value: "KoreaSouth", label: "Korea, South" },
  { value: "Kosovo", label: "Kosovo" },
  { value: "Kuwait", label: "Kuwait" },
  { value: "Kyrgyzstan", label: "Kyrgyzstan" },
  { value: "Laos", label: "Laos" },
  { value: "Latvia", label: "Latvia" },
  { value: "Lebanon", label: "Lebanon" },
  { value: "Lesotho", label: "Lesotho" },
  { value: "Liberia", label: "Liberia" },
  { value: "Libya", label: "Libya" },
  { value: "Liechtenstein", label: "Liechtenstein" },
  { value: "Lithuania", label: "Lithuania" },
  { value: "Luxembourg", label: "Luxembourg" },
  { value: "Madagascar", label: "Madagascar" },
  { value: "Malawi", label: "Malawi" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Maldives", label: "Maldives" },
  { value: "Mali", label: "Mali" },
  { value: "Malta", label: "Malta" },
  { value: "MarshallIslands", label: "Marshall Islands" },
  { value: "Mauritania", label: "Mauritania" },
  { value: "Mauritius", label: "Mauritius" },
  { value: "Mexico", label: "Mexico" },
  { value: "Micronesia", label: "Micronesia" },
  { value: "Moldova", label: "Moldova" },
  { value: "Monaco", label: "Monaco" },
  { value: "Mongolia", label: "Mongolia" },
  { value: "Montenegro", label: "Montenegro" },
  { value: "Morocco", label: "Morocco" },
  { value: "Mozambique", label: "Mozambique" },
  { value: "Myanmar", label: "Myanmar" },
  { value: "Namibia", label: "Namibia" },
  { value: "Nauru", label: "Nauru" },
  { value: "Nepal", label: "Nepal" },
  { value: "Netherlands", label: "Netherlands" },
  { value: "NewZealand", label: "New Zealand" },
  { value: "Nicaragua", label: "Nicaragua" },
  { value: "Niger", label: "Niger" },
  { value: "Nigeria", label: "Nigeria" },
  { value: "NorthMacedonia", label: "North Macedonia" },
  { value: "Norway", label: "Norway" },
  { value: "Oman", label: "Oman" },
  { value: "Pakistan", label: "Pakistan" },
  { value: "Palau", label: "Palau" },
  { value: "PalestineState" },
  { value: "Panama", label: "Panama" },
  { value: "PapuaNewGuinea", label: "Papua New Guinea" },
  { value: "Paraguay", label: "Paraguay" },
  { value: "Peru", label: "Peru" },
  { value: "Philippines", label: "Philippines" },
  { value: "Poland", label: "Poland" },
  { value: "Portugal", label: "Portugal" },
  { value: "Qatar", label: "Qatar" },
  { value: "Romania", label: "Romania" },
  { value: "Russia", label: "Russia" },
  { value: "Rwanda", label: "Rwanda" },
  { value: "SaintKittsNevis", label: "Saint Kitts and Nevis" },
  { value: "SaintLucia", label: "Saint Lucia" },
  {
    value: "SaintVincentGrenadines",
    label: "Saint Vincent and the Grenadines"
  },
  { value: "Samoa", label: "Samoa" },
  { value: "SanMarino", label: "San Marino" },
  { value: "SaoTomeAndPrincipe", label: "Sao Tome and Principe" },
  { value: "SaudiArabia", label: "Saudi Arabia" },
  { value: "Senegal", label: "Senegal" },
  { value: "Serbia", label: "Serbia" },
  { value: "Seychelles", label: "Seychelles" },
  { value: "SierraLeone", label: "Sierra Leone" },
  { value: "Singapore", label: "Singapore" },
  { value: "Slovakia", label: "Slovakia" },
  { value: "Slovenia", label: "Slovenia" },
  { value: "SolomonIslands", label: "Solomon Islands" },
  { value: "Somalia", label: "Somalia" },
  { value: "SouthAfrica", label: "South Africa" },
  { value: "Spain", label: "Spain" },
  { value: "SriLanka", label: "Sri Lanka" },
  { value: "Sudan", label: "Sudan" },
  { value: "SudanSouth", label: "Sudan, South" },
  { value: "Suriname", label: "Suriname" },
  { value: "Sweden", label: "Sweden" },
  { value: "Switzerland", label: "Switzerland" },
  { value: "Syria", label: "Syria" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Tajikistan", label: "Tajikistan" },
  { value: "Tanzania", label: "Tanzania" },
  { value: "Thailand", label: "Thailand" },
  { value: "Togo", label: "Togo" },
  { value: "Tonga", label: "Tonga" },
  { value: "TrinidadTobago", label: "Trinidad and Tobago" },
  { value: "Tunisia", label: "Tunisia" },
  { value: "Turkey", label: "Turkey" },
  { value: "Turkmenistan", label: "Turkmenistan" },
  { value: "Tuvalu", label: "Tuvalu" },
  { value: "Uganda", label: "Uganda" },
  { value: "Ukraine", label: "Ukraine" },
  { value: "UnitedArabEmirates", label: "United Arab Emirates" },
  { value: "UnitedKingdom", label: "United Kingdom" },
  { value: "UnitedStates", label: "United States" },
  { value: "Uruguay", label: "Uruguay" },
  { value: "Uzbekistan", label: "Uzbekistan" },
  { value: "Vanuatu", label: "Vanuatu" },
  { value: "Vatican City", label: "Vatican City" },
  { value: "Venezuela", label: "Venezuela" },
  { value: "Vietnam", label: "Vietnam" },
  { value: "Yemen", label: "Yemen" },
  { value: "Zambia", label: "Zambia" },
  { value: "Zimbabwe", label: "Zimbabwe" }
];
